export const scrollToSection = targetId => {
  const element = document.querySelector(`#${targetId}`);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  }
};